"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("@common/configuration");
const units_service_1 = require("./units.service");
class TerminationService extends units_service_1.UnitsService {
    constructor(token) {
        super(token);
        this.endpointBaseUrlV2 = configuration_1.Configuration.unitsServiceConfig().apiV2;
    }
    async getUnitTerminationStatus(legacyUnitId) {
        const response = await this.httpService.get(`${this.endpointV2}/unit-termination-status?filter[unit_id]=${legacyUnitId}`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async getUnitTerminationDetail(uuid) {
        const response = await this.httpService.get(`${this.endpointV2}/unit-terminations?filter[unit_id]=${uuid}`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async getTerminationCategoryReasons() {
        const response = await this.httpService.get(`${this.endpointV2}/termination-category-reasons`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async getUnitReturningReasons() {
        const unitStatusType = "20"; // This code allows filtering for termination returning reasons
        const response = await this.httpService.get(`${this.endpointV2}/termination-codes?filter[unit_status_type]=${unitStatusType}`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async getEmployeesByName(searchParam) {
        const response = await this.httpService.get(`${this.endpointV2}/employees?filter[first_name_and_last_name]=${searchParam}`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async getEmployeesById(id) {
        const response = await this.httpService.get(`${this.endpointV2}/employees/${id}`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async createUnitTerminationStatus(unitTerminationStatus) {
        const response = await this.httpService.post(`${this.endpointV2}/unit-termination-status`, { data: unitTerminationStatus }, { headers: this.getHeaders() });
        return response.data.data;
    }
    async updateUnitTerminationStatus(id, unitTerminationStatus) {
        const response = await this.httpService.patch(`${this.endpointV2}/unit-termination-status/${id}`, { data: unitTerminationStatus }, { headers: this.getHeaders() });
        return response.data.data;
    }
    async createUnitTerminationDetail(unitTerminationStatus) {
        const response = await this.httpService.post(`${this.endpointV2}/unit-terminations`, { data: unitTerminationStatus }, { headers: this.getHeaders() });
        return response.data.data;
    }
}
exports.TerminationService = TerminationService;
//# sourceMappingURL=termination.service.js.map